export default "__VITE_ASSET__DOlG3Gec__"